module.exports = __webpack_public_path__ + "img/partner6.7616169d.png";